import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntInsertAfterViewInitDirective} from "./int-insert-after-view-init.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [IntInsertAfterViewInitDirective],
  exports: [IntInsertAfterViewInitDirective]
})
export class IntInsertAfterViewInitModule {}
